import { ENDPOINTS } from 'src/constants/endpoints'

import {
  GOOGLE_AUTH_URL,
  GOOGLE_CLIENT_ID,
  GOOGLE_SCOPES,
  KN_API_BASE_URL,
  MICROSOFT_AUTH_URL,
  MICROSOFT_CLIENT_ID,
  MICROSOFT_SCOPES,
} from 'src/app/auth/constants/oauth'
import type { OAuthProvider } from 'src/app/auth/domain/models/oauth-provider'

export interface IBuildOAuthUrlParams {
  provider: OAuthProvider
  clientOrigin: string
}

const redirectUri = (provider: OAuthProvider): string =>
  `${KN_API_BASE_URL}${ENDPOINTS.auth.oauthCallback(provider)}`

const buildGoogleUrl = (clientOrigin: string): string => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: redirectUri('google'),
    access_type: 'offline',
    scope: GOOGLE_SCOPES,
    prompt: 'consent',
    state: JSON.stringify({
      source: 'google',
      client_redirect_url: clientOrigin,
    }),
  })
  return `${GOOGLE_AUTH_URL}?${params.toString()}`
}

const buildMicrosoftUrl = (clientOrigin: string): string => {
  const params = new URLSearchParams({
    client_id: MICROSOFT_CLIENT_ID,
    response_type: 'code',
    redirect_uri: redirectUri('microsoft'),
    response_mode: 'query',
    scope: MICROSOFT_SCOPES,
    state: JSON.stringify({
      source: 'microsoft',
      scopes: MICROSOFT_SCOPES,
      client_redirect_url: clientOrigin,
    }),
  })
  return `${MICROSOFT_AUTH_URL}?${params.toString()}`
}

export const buildOAuthUrl = (params: IBuildOAuthUrlParams): string => {
  if (params.provider === 'google') return buildGoogleUrl(params.clientOrigin)
  if (params.provider === 'microsoft')
    return buildMicrosoftUrl(params.clientOrigin)
  throw new Error('buildOAuthUrl: unknown provider')
}
